import * as React from 'react';
import { Field } from 'redux-form';

import { SegmentLabel } from '@acceligentllc/storybook';

import Checkbox from 'af-fields/Checkbox';
import Input from 'af-fields/Input';

import WorkRequestUpsertFM from '../../formModel';
import { formSectionClass, formSectionClassColumn2, formSectionClassColumn4, formSectionClassRow } from '../../helpers';
import styles from '../../styles.module.scss';

const PublicSafetySection: React.FC = () => {
	const checkboxStyle = React.useMemo(() => [formSectionClassColumn2, styles['work-request-form__tab-content__form-section__row__centered-column']].join(' '), []);

	return (
		<div className={formSectionClass}>
			<SegmentLabel
				label="Public Safety"
				tooltip="Public safety measures required for this job, addressing potential risks to vehicle traffic and pedestrian movement in and around the job site."
			/>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="vehicleTraffic"
						label="Vehicle Traffic"
						name={WorkRequestUpsertFM.getAttributeName('vehicleTraffic')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="vehicleTrafficDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('vehicleTrafficDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
			<div className={formSectionClassRow}>
				<div className={checkboxStyle}>
					<Field
						component={Checkbox}
						id="pedestrianCrossing"
						label="Pedestrian Crossing"
						name={WorkRequestUpsertFM.getAttributeName('pedestrianCrossing')}
					/>
				</div>
				<div className={formSectionClassColumn4}>
					<Field
						component={Input}
						id="pedestrianCrossingDescription"
						label="Description"
						name={WorkRequestUpsertFM.getAttributeName('pedestrianCrossingDescription')}
						placeholder="Enter Description"
						type="text"
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(PublicSafetySection);
